import * as React from 'react';
import { api, CreateCaseDraftData } from './create/api';
import { api as apiEdit } from './edit/api';
import { AppSetting } from 'dependencies/appsettings';
import ReCAPTCHA from 'react-google-recaptcha';
import { toStartupView } from 'app/area/shared/navigation';

// eslint:disable-next-line: max-func-body-length
// eslint-disable-next-line no-shadow, no-unused-vars
export const withRecaptchaApi = (WrappedComponentFactory: (api?: any) => React.ComponentType<React.PropsWithChildren<unknown>>) => {
  if (!AppSetting.GoogleRecaptchaSiteKey) {
    return WrappedComponentFactory();
  }

  let captchaToken: string = undefined;
  
  const captchaApi = {
    createCase: async (
      bodyParameters: CreateCaseDraftData,
      queryParameters?: { [key: string]: string | number }
    ): Promise<number> => api.createCase(bodyParameters, queryParameters, captchaToken),
    editCase: async (
      caseId: number, 
      caseContextId: number = undefined
    ): Promise<{ location: number; response: any }> => apiEdit.editCase(caseId, caseContextId, captchaToken)
  };

  const Container = WrappedComponentFactory(captchaApi);

  return class RecaptchaHandler extends React.Component<any, any> {
    private recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();
    private observer: MutationObserver;
    private timeout: any;

    public state: Readonly<any> = {
      ready: false
    };

    public componentDidMount() {
      this.recaptchaRef.current.execute();
      this.initObserver();
    }

    private initObserver = () => {
      // Monitor if the user closes the challenge window. There is no JS api for this.
      this.timeout = undefined;
      const errorHandler = this.handleError;
      const frames = Array.from(document.getElementsByTagName('iframe'));
      let recaptchaWindow: HTMLElement;

      frames.forEach(x => {
        if (x.src.includes('google.com/recaptcha/api2/bframe')) {
          recaptchaWindow = x.parentNode.parentNode as HTMLElement;
        }
      });

      if (!recaptchaWindow) {
        this.timeout = setTimeout(() => this.initObserver(), 100);
        return;
      }

      this.observer = new MutationObserver(() => {
        if (recaptchaWindow && Number(recaptchaWindow.style.opacity) === 0) {
          this.observer.disconnect();
          errorHandler();
        }
      });
      this.observer.observe(recaptchaWindow, { attributes: true, attributeFilter: ['style'] });
    };

    public componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    private handleSubmit = (token: string) => {
      captchaToken = token;
      this.setState({ ready: true });
    };

    private handleError = () => {
      toStartupView();
    };

    public render() {
      const { ready } = this.state;

      if (!ready) {
        return (
          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={AppSetting.GoogleRecaptchaSiteKey}
            onChange={this.handleSubmit}
            onErrored={this.handleError}
            onExpired={this.handleError}
            size="invisible"
          />
        );
      }

      return <Container {...this.props} />;
    }
  };
};
